<section
  [ngClass]="'content-section content-section--' + theme()"
  [attr.id]="'section-' + id()"
>
  <div class="container">
    <ng-content />
  </div>
</section>
